import React from 'react';
import { useTranslate } from '../i18n/LanguageProvider';
import Image from 'gatsby-image';

const Footer = ({ logos }) => {
	const translate = useTranslate();

	return (
    <footer className="footer">
      <div className="container">
        <div className="columns">
          <div className="column is-6">
            <h2>
              <strong>{translate("Varbla Puhkeküla AS")}</strong>
            </h2>
            <ul>
              <li>{translate("contact.address")}</li>
              <li>{translate("contact.mobile")}</li>
              <li>{translate("contact.email")}</li>
              <li>
                <a
                  href="https://www.facebook.com/varblapuhkekyla/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  FB: varblapuhkekyla
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/varblapuhkekyla/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  IG: varblapuhkekyla
                </a>
              </li>
            </ul>
          </div>
          <div className="column is-6 footer-logos">
            {logos && (
              <>
                {logos.rannateeLogo && (
                  <a
                    href="https://rannatee.ee/varbla-puhkekula/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image fixed={logos.rannateeLogo.childImageSharp.fixed} />
                  </a>
                )}
                {logos.leaderLogo && (
                  <a
                    href="https://www.agri.ee/et/eesmargid-tegevused/maaettevotlus-ja-maaelu/leader"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image fixed={logos.leaderLogo.childImageSharp.fixed} />
                  </a>
                )}
                {logos.leaderLogo2 && (
                  <a
                    href="https://www.agri.ee/et/eesmargid-tegevused/maaettevotlus-ja-maaelu/leader"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image fixed={logos.leaderLogo2.childImageSharp.fixed} />
                  </a>
                )}
                {logos.euLogo && (
                  <a
                    href="https://www.agri.ee/et/eesmargid-tegevused/maaettevotlus-ja-maaelu/leader"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image fixed={logos.euLogo.childImageSharp.fixed} />
                  </a>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
